<div class="overlay" (click)="onBackdropClick($event)">
  <div class="dialog" role="dialog" aria-modal="true" [attr.aria-label]="title">
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
    <div class="actions">
      <app-mb-button flat (click)="cancelled.emit()">{{ cancelText }}</app-mb-button>
      <app-mb-button error (click)="confirmed.emit()">{{ confirmText }}</app-mb-button>
    </div>
  </div>
</div>
